module.exports = __webpack_public_path__ + "img/logo_water.229a7c56.png";